import { PreOrderUserRole } from '../types'

export default function isPreOrderHostUserRole(
  preOrderUserRole: PreOrderUserRole,
) {
  return preOrderUserRole === PreOrderUserRole.Host
}
